import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7OPCVMCompositionsEdit } from "./edit";
import { A7OPCVMCompositionsTable } from "./table";

export default function A7OPCVMCompositions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | OPCVM Compositions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7OPCVMCompositionsEdit />} />
      <Route index element={<A7OPCVMCompositionsTable />} />
    </Routes>
  );
}
